export const SET_TASKS = 'Tasks/set';
export const SET_TASKS_UPDATED = 'Tasks/UpdateStatus/set';
